module.exports = __webpack_public_path__ + "img/phone-call.07e4cdaf.gif";